import { render, staticRenderFns } from "./BotaoAvancarSalvarItens.vue?vue&type=template&id=8bd3e78a&scoped=true"
import script from "./BotaoAvancarSalvarItens.vue?vue&type=script&lang=js"
export * from "./BotaoAvancarSalvarItens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd3e78a",
  null
  
)

export default component.exports